<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <dropdown :class="['mr-1']" v-model="rounded" :items="roundness" :width="dropdownsWidth" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" /><!--
          --><dropdown :class="['mr-1']" v-model="ambience" :items="ambiences" :width="dropdownsWidth" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" /><!--
          --><dropdown :class="['mr-1']" v-model="spread" :items="spreads" :width="dropdownsWidth" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" /><!--
          --><dropdown :class="['mr-1']" v-model="direction" :items="directions" :width="dropdownsWidth" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="8" sm12 xs24 v-for="image in 6" :key="image">
        <card>
          <card-text padding-off :class="['p-10']">
            <ambient-image :title="getImageUrl(image)" @click="log('click', 'ambient-image', getImageUrl(image))" :class="['cursor-pointer']" :rounded="rounded[0]" :ambience="ambience[0]" :spread="spread[0]" :direction="direction[0]" :src="getImageUrl(image)" />
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageAmbientImage',
  mixins: [
    methods
  ],
  data () {
    return {
      images: [],
      dropdownsWidth: '135px',
      direction: ['center'],
      spread: [14],
      ambience: [14],
      rounded: ['xl'],
      directions: ['negative', 'center', 'positive'].map(value => {
        return {
          value,
          text: this.firstLetterCapital(value)
        }
      }),
      spreads: Array.from(Array(24).keys()).map(value => {
        return {
          value: value + 1,
          text: this.$lang.spread(value + 1)
        }
      }),
      ambiences: Array.from(Array(24).keys()).map(value => {
        return {
          value: value + 1,
          text: this.$lang.ambience(value + 1)
        }
      }),
      roundness: ['none', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', 'full'].map(value => {
        return {
          value,
          text: this.$lang.roundedLabel(value)
        }
      })
    }
  },
  methods: {
    getImageUrl (index) {
      return `${this.$root.config.staticAssetsDir}/images/misc/image-0${index}.jpeg`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/ambient-image.vue